import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "cropperjs/dist/cropper.css";
import { useDispatch } from "react-redux";
import { handleUpload, updateAudioAds, updateUserProfile } from "../../store/slices/authSlice";
import { toast } from "react-toastify";
import AWS from 'aws-sdk';
import { CLOUDFLARE_BUCKET } from '../../constants';
import { useSelector } from "react-redux";

const accessKeyId = CLOUDFLARE_BUCKET.accessKeyId;
const secretAccessKey = CLOUDFLARE_BUCKET.secretAccessKey;
const bucketName = CLOUDFLARE_BUCKET.bucketName;
const audioBucketName = CLOUDFLARE_BUCKET.audioBucketName;
const region = CLOUDFLARE_BUCKET.region;
const endpoint = CLOUDFLARE_BUCKET.endpoint;
const bucketUrl = CLOUDFLARE_BUCKET.bucket_url;
const audioBucketUrl = CLOUDFLARE_BUCKET.audio_bucket_url;

const s3Client = new AWS.S3({
    accessKeyId,
    secretAccessKey,
    region,
    endpoint,
});

const AudioModel = ({ show, onClose, audio , onUploadSuccess}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { attributes: { audioAds } } = user;

    const [progress, setProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [audioFileUrl, setAudioFileUrl] = useState(null);

    useEffect(() => {
        if (audio) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setAudioFileUrl(e.target.result); // Set the data URL for preview
            };
            reader.readAsDataURL(audio);
        }
    }, [audio]);

    const uploadAudioFile = async () => {
        if (!audio) {
            toast.error("Please upload an audio file!");
            return;
        }

        try {
            const uniqueFileName = `${Date.now()}_${audio.name}`;
            const uploadParams = {
                Bucket: audioBucketName,
                Key: uniqueFileName,
                Body: audio,
            };

            const uploadPromise = s3Client.upload(uploadParams).on("httpUploadProgress", (progress) => {
                const percentageUploaded = Math.floor((progress.loaded / progress.total) * 100);
                setProgress(percentageUploaded);
            }).promise();

            const response = await uploadPromise;
            const audioUrl = `${audioBucketUrl}/${response.Key}`;
            const audioIdentifier = audio.name.replace(/\.[^/.]+$/, "");


            if (onUploadSuccess) {
                onUploadSuccess(audioUrl, audioIdentifier);
              } else {
                // Get existing videos or initialize empty array
                const existingAudios = audioAds?.audios || [];
                const isForStation = user?.attributes?.isOwner == false ? true : false;
                const updatedAudios = [
                  ...existingAudios,
                  { audio: audioUrl,audioIdentifier }
                ];
                
                dispatch(updateAudioAds({
                  values: { audioAds: { audios: updatedAudios } },
                  message: "Audio uploaded successfully!",
                  isForStation
                }));
                onClose();
              }


            setIsUploading(false);
            onClose();
        } catch (error) {
            console.error("Error uploading audio:", error);
            toast.error("Failed to upload audio!");
            setIsUploading(false);
        }
    };

    return (
        <Modal show={show} size="md" onHide={onClose} centered backdrop="static" keyboard={false}>
            <div>
                <div className="adjust-banner-container">
                    <div className="adjust-banner-title pb-4">Preview</div>
                    {audioFileUrl && <audio src={audioFileUrl} controls style={{ width: "100%" }} />}
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="cancel-btn" onClick={onClose} disabled={isUploading}>
                    Cancel
                </button>
                <button type="button" className="upload-btn" onClick={uploadAudioFile} disabled={isUploading}>
                    {isUploading ? `Uploading... ${progress}%` : "Upload"}
                </button>
            </div>
        </Modal>
    );
};

export default AudioModel;
